import Button from '@/common/components/Button'
import { ArrowBigRight } from 'lucide-react'
import { Link } from 'react-router-dom'
import { productNfceMappingStatusStrategy } from '../constants/statusOptions.constant'
import { ProductNfceMappingData } from '../types/productNfceMapping'

export class ProductNfceMappingsTransformer {
  static tableTransformer() {
    return (productNfceMappings: ProductNfceMappingData[]) => {
      return productNfceMappings.map((mapping) => ({
        ...mapping,
        status:
          productNfceMappingStatusStrategy[mapping.status as keyof typeof productNfceMappingStatusStrategy] ||
          mapping.status,
        name: mapping.name ?? '',
        product_name: mapping.product?.display_name ?? '',
        actions: (
          <Link to={`/product-nfce-mappings/${mapping.id}`} className="cursor-pointer">
            <Button
              name="access_product_nfce_mapping_show"
              className="w-full"
              variant="link-white"
              operationKlassToCheckPermission="Admin::ProductNfceMappings::Show"
            >
              <ArrowBigRight />
            </Button>
          </Link>
        ),
      }))
    }
  }
}
